import { render, staticRenderFns } from "./HistoryTexteditorModal.vue?vue&type=template&id=9ba80d6a&scoped=true"
import script from "./HistoryTexteditorModal.vue?vue&type=script&lang=js"
export * from "./HistoryTexteditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba80d6a",
  null
  
)

export default component.exports